import '@babel/polyfill';
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import install from "./libs/install";

import "./assets/css/base.scss";
import "video.js/dist/video-js.css";
import { initMob, isPhoneDevice } from './libs/funtions';

Vue.config.productionTip = false;

Vue.use(install);

if (isPhoneDevice()) {
  initMob();
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
